import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  labelWidth: '120px',
  formItems: [
    {
      field: 'deptId',
      type: 'select',
      label: '部门',
      clearable: true,
      placeholder: '请选择部门'
    },
    {
      field: 'developerNames',
      type: 'select',
      label: '开发人员',
      clearable: true,
      filterable: true,
      placeholder: '请选择开发人员'
    },
    {
      field: 'teachingStaffIds',
      type: 'select',
      label: '投教人员',
      clearable: true,
      filterable: true,
      placeholder: '请选择投教人员'
    },
    {
      label: '客户姓名/昵称',
      field: 'customerName',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户昵称/名字'
    },
    {
      field: 'corpName',
      type: 'select',
      label: '企业',
      clearable: true,
      placeholder: '请选择企业',
      filterable: true,
      options: []
    },
    {
      label: '资源渠道',
      field: 'resourceChannel',
      type: 'select',
      clearable: true,
      placeholder: '请选择资源渠道',
      options: [
        { title: '诊股', value: '诊股' },
        { title: '荐股', value: '荐股' },
        { title: '信息流', value: '信息流' }
      ]
    },
    {
      label: '是否签合同',
      field: 'isSigned',
      type: 'select',
      clearable: true,
      placeholder: '请选择是否签合同',
      options: [
        { title: '否', value: '否' },
        { title: '是', value: '是' }
      ]
    },
    {
      field: 'favoriteTeacher',
      type: 'select',
      label: '认可老师',
      clearable: true,
      placeholder: '请选择老师'
    },
    {
      label: '客户编码',
      field: 'customerId',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户编码'
    },
    {
      field: 'resourceTime',
      type: 'datepicker',
      label: '资源时间',
      clearable: true,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      field: 'billingTime',
      type: 'datepicker',
      label: '开单时间',
      clearable: true,
      otherOptions: {
        startPlaceholder: '起始日期',
        endPlaceholder: '结束日期',
        type: 'daterange',
        'value-format': 'YYYY-MM-DD',
        disabledDate: (date: Date) => {
          return new Date() < date
        }
      }
    },
    {
      label: '是否核实',
      field: 'verifyResult',
      type: 'select',
      clearable: true,
      placeholder: '请选择审核结果',
      options: [
        { title: '待审核', value: '待审核' },
        { title: '属实', value: '属实' },
        { title: '不属实', value: '不属实' }
      ]
    }
  ]
}
